import { render, staticRenderFns } from "./DatastudioContent.vue?vue&type=template&id=5a686cc0"
import script from "./DatastudioContent.vue?vue&type=script&lang=js"
export * from "./DatastudioContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports